"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FEATURE_FLAG_FIREFOX_SUPPORT = void 0;
// There is no Firefox support yet, the waitForFunction method
// does not yet work and downloading has a bug.
// Disabling this for now!
exports.FEATURE_FLAG_FIREFOX_SUPPORT = false;
//# sourceMappingURL=feature-flags.js.map